/**
 * Общее для мини-игр умения (F1–F7): это не азарт, тяга всегда 0,
 * текст ожидания не показывается. Игры при решении (`decision`) читают
 * `life.pendingDecision`: исход — `decisionOption`, который клиент отдаёт
 * в `YearInput.answer`; «пропустить» — автовыбор решения (`timeoutOption`).
 */
import type { Decision, DecisionKind, Life, Rng } from '@life/engine';

/** Висящее решение одного из заданных видов, иначе null. */
export function pendingOf(life: Life, kinds: readonly DecisionKind[]): Decision | null {
  const d = life.pendingDecision;
  return d !== null && kinds.includes(d.kind) ? d : null;
}

/** Доступен ли вариант решения с этим id. */
export function optionAvailable(decision: Decision, id: string): boolean {
  return decision.options.some((o) => o.id === id && o.available);
}

/** Перемешать копию списка (Фишер–Йетс) жребием `rng`. */
export function shuffle<T>(items: readonly T[], rng: Rng): T[] {
  const out = [...items];
  for (let i = out.length - 1; i > 0; i -= 1) {
    const j = rng.int(0, i);
    const tmp = out[i] as T;
    out[i] = out[j] as T;
    out[j] = tmp;
  }
  return out;
}

/** Исход без изменений: ни денег, ни тяги. */
export function nothing(): { moneyDelta: number; urgeDelta: number } {
  return { moneyDelta: 0, urgeDelta: 0 };
}
